export const CREATE_SPV_MODAL_TITLES = [
  "Create Entity",
  "Legal Doc Templates",
  "File EIN",
  "Status Update",
];
